import React from 'react';
import { defaultUnitsMock } from '../mock/NewReportMocks';
import './ColumnDraggableItem.scss';

export interface ColumnDraggableItemProps {
  category: string;
  name: string;
  unit?: string;
  onRemove: () => void;
  onChangeOption: (value: string) => void;
}

export const ColumnDraggableItem: React.FC<ColumnDraggableItemProps> = ({
  name,
  category,
  unit,
  onRemove = () => {},
  onChangeOption = () => {},
}): JSX.Element => (
  <div className="column-draggable-item">
    <div className="column-draggable-item__text">
      {category} / {name}
    </div>

    {unit ? (
      <select
        onChange={(e) => onChangeOption(e.target.value)}
        className="column-draggable-item__badge"
        value={unit}
      >
        {defaultUnitsMock.map((option) => (
          <option key={option}>{option}</option>
        ))}
      </select>
    ) : null}

    <button
      onClick={onRemove}
      type="button"
      className="column-draggable-item__remove"
    >
      &times;
    </button>
  </div>
);
